<template>
  <layout-view navTitle="Фильтры">
    <template v-slot:nav>
      <portal to="back">
        <v-btn icon @click="$router.push('../')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </portal>
      <div class="px-4">
        <user-autocomplete-multiple name="Специалисты" _type="spec" :select.sync="filter.usersSpecSelected"/>
        <spec-autocomplete-multiple :select.sync="filter.specsSelected"/>

        <v-btn small block depressed color="silver" @click="selectedTemplate={}">
          Создать профиль
        </v-btn>
      </div>
    </template>
    <template v-slot:content="{height}">
      <n-table-view
        ref="table"
        name="Шаблоны зарплаты"
        :genRequestBuilder="genRequestBuilder"
        :height="height"
        :headers="[
            { text: 'ID', value:'id', sortable: true},
            { text: 'Название', value:'name', sortable: true},
            { text: 'Специалист', value:'salarys', sortable: false},
            { text: 'Комментарий', value:'durationDays', sortable: true},
          ]"
        :selectAll.sync="templatesSelectAll"
        :selectIndeterminate="templatesSelectIndeterminate"  
      >
        <template v-slot:barActions>

            <v-btn
                v-if="selectedTemplates.length>0"
                @click="$confirm('Удалить шаблоны','Вы уверены, что хотите удалить выбранные шаблоны?', ()=>salaryTemplatesDelete())"
                depressed small
                :disabled="selectedTemplates.length===0"
                class="mr-2"
            >
              Удалить шаблоны ({{selectedTemplates.length}})
            </v-btn>
      
        </template>
        <template v-slot:item="{ item }">
          <tr @click="selectedTemplate=item">
            <td>
              <v-checkbox @click.stop="$tools.selectToggle(selectedTemplates, item)" :input-value="$tools.isSelect(selectedTemplates, item)" class="ma-0 pa-0" dense hide-details />
            </td>
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td :data-print="specs(item.salarys)">
              <template v-for="(i,index) in item.salarys">        
                <tooltip right :key="'user_'+i.id+index">
                  <UserFullName :user="i.user" type="spec"/>
                  <template v-slot:content>
                    <template v-for="(userSpec,idx) in i.user.userSpecs">
                      <div class="caption"  :key="'us_'+userSpec.id+idx">
                        <div>
                          <v-avatar :color="userSpec.comDiv.comBranch.color" size="10" class="mr-1" style="margin-top:-2px"/>
                          {{userSpec.spec.name}} ({{ userSpec.comDiv.comBranch.name }})
                        </div>
                      </div>
                    </template>
                  </template>
                </tooltip>
              </template>
            </td>
            <td>{{ item.comment }}</td>
          </tr>
        </template>
      </n-table-view>

    <dialog-editor :item.sync="selectedTemplate" :name="`${selectedTemplate?.id ? selectedTemplate.name : 'Новый шаблон'}`" fullscreen submitText="Сохранить" @submit="salaryTemplatesSave()" content-padding-remove disableOverlayClick :color="$mainColor">
      <SalaryForm :salary.sync="selectedTemplate" :height="height+80" @update="$refs.table.load()"/>
    </dialog-editor>

    </template>
  </layout-view>
</template>

<script>
import axios from "axios";
import Api from "@/Api";
import LayoutView from "@/components/LayoutView";
import NTableView from "@/componentsV2/base/NTableView.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import UserAutocompleteMultiple from "@/componentsV2/custom/UserAutocompleteMultiple.vue";
import SpecAutocompleteMultiple from "@/componentsV2/custom/SpecAutocompleteMultiple.vue";
import DialogEditor from "@/componentsV2/base/DialogEditor.vue";
import SalaryForm from "@/views/Salary/SalaryForm.vue";


import {
  Entity_SalaryTemplate, 
  Entity_SalaryTemplateService, 
  Entity_Service,
  Entity_Salary,
  Entity_UserSpec, 
  Entity_User,
  Entity_Spec,
  Entity_ComDiv,
  Entity_ComBranch
} from "../../../EntityStoreCacheService";



export default {
  components: {
    NTableView,
    LayoutView,
    UserFullName,
    Tooltip,
    UserAutocompleteMultiple,
    SpecAutocompleteMultiple,
    DialogEditor,
    SalaryForm 
  },

  data:()=>({
    filter: {
      usersSpecSelected:[],
      specsSelected:[],
    },
    selectedTemplate: null,
    templates:[],
    selectedTemplates:[],
    salaryFormHeaderColor: process.env.VUE_APP_COLOR
  }),
  computed: {
    templatesSelectAll:{
      get(){
        return this.$tools.isSelectAll(this.templates, this.selectedTemplates)
      },
      set(){
        this.$tools.selectAllToggle(this.templates, this.selectedTemplates)
      }
    },
    templatesSelectIndeterminate:{
      get(){
        return this.$tools.isSelectIntermidiate(this.templates, this.selectedTemplates)
      },
    },
  },
  watch:{
    filter: {
      handler() {
        this.$refs.table.load();
      },
      deep: true,
    }
  },
  methods:{
    genRequestBuilder(page, onPage, sortFields){
      let rb =  new Entity_SalaryTemplate()
        .selects(Entity_SalaryTemplate.id)
        .selects(Entity_SalaryTemplate.name)
        .selects(Entity_SalaryTemplate.comment)
        .selects(Entity_SalaryTemplate.createVisitMode)
        .selects(Entity_SalaryTemplate.createVisit)
        .selects(Entity_SalaryTemplate.renMode)
        .selects(Entity_SalaryTemplate.ren)
        .selects(Entity_SalaryTemplate.refMode)
        .selects(Entity_SalaryTemplate.ref)
        .selects(Entity_SalaryTemplate.regMode)
        .selects(Entity_SalaryTemplate.reg)
        .selects(Entity_SalaryTemplate.rateMode)
        .selects(Entity_SalaryTemplate.rate)
        .selects(Entity_SalaryTemplate.rateMaxMode)
        .selects(Entity_SalaryTemplate.rateMax)
        .selects(Entity_SalaryTemplate.isRateServiceDiscount)
        .selects(Entity_SalaryTemplate.isCountingFromMargin)
  
        .selects([Entity_SalaryTemplate.salaryTemplateServices, Entity_SalaryTemplateService.id].join('.'))
        .selects([Entity_SalaryTemplate.salaryTemplateServices, Entity_SalaryTemplateService.ren].join('.'))
        .selects([Entity_SalaryTemplate.salaryTemplateServices, Entity_SalaryTemplateService.renMode].join('.'))
        .selects([Entity_SalaryTemplate.salaryTemplateServices, Entity_SalaryTemplateService.service, Entity_Service.id].join('.'))
        .selects([Entity_SalaryTemplate.salaryTemplateServices, Entity_SalaryTemplateService.service, Entity_Service.name].join('.'))
        .selects([Entity_SalaryTemplate.salaryTemplateServices, Entity_SalaryTemplateService.service, Entity_Service.priceTotal].join('.'))

        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.id].join('.'))
        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.begin].join('.'))
        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.comBranch, Entity_ComBranch.id].join('.'))
        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.comBranch, Entity_ComBranch.name].join('.'))
        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.comBranch, Entity_ComBranch.color].join('.'))
        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.user, Entity_User.id].join('.'))
        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.user, Entity_User.firstName].join('.'))
        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.user, Entity_User.lastName].join('.'))
        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.user, Entity_User.secondName].join('.'))
        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.user, Entity_User.imageUrl].join('.'))

        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.user, Entity_User.userSpecs, Entity_UserSpec.id ].join('.'))
        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.user, Entity_User.userSpecs, Entity_UserSpec.spec, Entity_Spec.id ].join('.'))
        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.user, Entity_User.userSpecs, Entity_UserSpec.spec, Entity_Spec.name ].join('.'))
        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.user, Entity_User.userSpecs, Entity_UserSpec.spec, Entity_Spec.color ].join('.'))

        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.user, Entity_User.userSpecs, Entity_UserSpec.comDiv, Entity_ComDiv.name ].join('.'))
        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.user, Entity_User.userSpecs, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch, Entity_ComBranch.id ].join('.'))
        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.user, Entity_User.userSpecs, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch, Entity_ComBranch.name ].join('.'))
        .selects([Entity_SalaryTemplate.salarys, Entity_Salary.user, Entity_User.userSpecs, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch, Entity_ComBranch.color ].join('.'))

        if (!this.$tools.isEmpty(this.filter.usersSpecSelected))
          rb.filterAnd([Entity_SalaryTemplate.entity, Entity_SalaryTemplate.salarys, Entity_Salary.user, Entity_User.id ].join('.')+' in (?)',  this.filter.usersSpecSelected.map(i=>i.id))
      
        if (!this.$tools.isEmpty(this.filter.specsSelected))
          rb.filterAnd([Entity_SalaryTemplate.entity, Entity_SalaryTemplate.salarys, Entity_Salary.user, Entity_User.userSpecs, Entity_UserSpec.spec, Entity_Spec.id].join('.')+' in (?)',  this.filter.specsSelected.map(i=>i.id))
          
        rb.page(1)
        rb.onPage(1000)

        sortFields.forEach(v=>{
          rb.order(v.field, v.isAsc)
        })

        rb.addStateCallback((v)=>{
          this.templates = v.items
        })

        return rb;
    },
    salaryTemplatesSave() {
      if (this.selectedTemplate.id!==undefined&&this.selectedTemplate.id) {
        axios.put(Api.host+'/salary/template/'+this.selectedTemplate.id+'/', this.selectedTemplate).then(()=>{
          this.selectedTemplate = null;
          this.$refs.table.load();
          this.$store.commit('alertSuccess', 'Профиль сохранен');
        }).catch((e)=>{
          console.error(e);
        });
      } else {
         axios.post(Api.host+'/salary/template/', this.selectedTemplate).then(()=>{
          this.selectedTemplate = null;
          this.$refs.table.load();
          this.$store.commit('alertSuccess', 'Профиль создан');
        }).catch((e)=>{
          console.error(e);
        });
      }
    },
    salaryTemplatesDelete(){
      let salaryTemplatesIds = this.selectedTemplates.map(i=>i.id).join(',')
      axios.delete(Api.host+`/salary/template/multiple?salaryTemplatesIds=${salaryTemplatesIds}`).then(()=>{
        this.selectedTemplates = [];
        this.$refs.table.load();
        this.$store.commit('alertSuccess', 'Профиль удален');
      });
    },
    specs(items) {
      let users = '';
      items.forEach(i=>{
        users+=this.$tools.userFullName(i.user,false)+'\n'
      })
      return users;
    }
  }
}
</script>